
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { EnvironmentVarsService } from '@go-modules/services/environment-vars/environment-vars.service';
import { ENVIRONMENTS } from '@go-modules/services/environment-vars/environments';
import { TranslateModule } from '@ngx-translate/core';

@Component({
	selector: 'logo',
	templateUrl: 'logo.component.html',
	styleUrls: ['./logo.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [
		TranslateModule
	]
})
export class LogoComponent {
	public environmentVarsService: EnvironmentVarsService;

	constructor () {
		this.environmentVarsService = EnvironmentVarsService.getInstance();
	}

	public get version (): string {
		return this.environmentVarsService.get(EnvironmentVarsService.VAR.ENVIRONMENT).version;
	}

	public get isLTI (): boolean {
		return this.environmentVarsService.environmentIs(ENVIRONMENTS.LTI);
	}
}
